import * as moment from 'moment';
import * as React from 'react';
import * as Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import {DATE_FORMAT} from '../../Config/appConfig';
import '../../style/calendar.css';

const calendarIcon = require('../../resource/img/calendar.svg');

interface CalendarProps {
    date: moment.Moment,
    onChange: (newDate: any) => void,
    isValidDate?: (date: moment.Moment) => boolean,
    disabled: boolean,
    timeFormat?: boolean
}

class Calendar extends React.Component <CalendarProps, {}> {
    public constructor(props: CalendarProps) {
        super(props);
        this.changeDate = this.changeDate.bind(this);
    }

    public changeDate(date: moment.Moment) {
        this.props.onChange(moment(date, DATE_FORMAT.DATETIME, true).isValid() ? date : moment(this.props.date));
    }

    public render() {
        return (
            <div className="cmCalendarContainer">
                <img src={calendarIcon}/>
                <Datetime
                    dateFormat={DATE_FORMAT.DATE}
                    value={this.props.date}
                    onChange={this.changeDate}
                    isValidDate={this.props.isValidDate}
                    timeFormat={this.props.timeFormat ? DATE_FORMAT.TIME : false}
                    inputProps={{disabled: this.props.disabled, className: "cmText cmCalendar"}}/>
            </div>
        );
    }
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/Components/Custom/Calendar.tsx